/**
 * The two icons the game needs that the shell's set (components/Icon.tsx)
 * doesn't have, drawn in the same chunky 24×24 rounded-stroke style.
 * Decorative: the button around an icon carries the accessible name.
 */
export type GameIconName = 'pause' | 'choices';

export function GameIcon({ name, size = '1.25em' }: { name: GameIconName; size?: string }) {
  return (
    <svg
      className="game-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {name === 'pause' ? (
        <>
          <rect x="6" y="5" width="4" height="14" rx="1.6" fill="currentColor" />
          <rect x="14" y="5" width="4" height="14" rx="1.6" fill="currentColor" />
        </>
      ) : (
        <>
          <rect x="4" y="4" width="7" height="7" rx="2" />
          <rect x="13" y="4" width="7" height="7" rx="2" />
          <rect x="4" y="13" width="7" height="7" rx="2" />
          <rect x="13" y="13" width="7" height="7" rx="2" />
        </>
      )}
    </svg>
  );
}
